// index.ts
import { bbox } from "@turf/bbox";
import { point } from "@turf/helpers";
function center(geojson) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ext = bbox(geojson);
    var x = (ext[0] + ext[2]) / 2;
    var y = (ext[1] + ext[3]) / 2;
    return point([
        x,
        y
    ], options.properties, options);
}
var turf_center_default = center;
export { center, turf_center_default as default }; //# sourceMappingURL=index.js.map
